import {
  Component,
  OnInit,
  ElementRef,
  Output,
  EventEmitter,
} from "@angular/core";
import { Claims } from "src/app/_models/common/claims";
import { ClaimsService } from "src/app/_services/common/claims.service";
import { DateFormatPipe } from "src/app/_helpers/pipe.module";
import { IApiRequest, ApiRequest } from "src/app/_models";
import { first } from "rxjs/operators";
import { ToastrService } from "ngx-toastr";
import { Router, ActivatedRoute } from "@angular/router";
import { OrganisationSubscriptionInvoiceService } from "src/app/_services/billing-pricing/Organisation-Subscription-Invoice.service";
import { FunctionDetail } from "src/app/_models/billing-pricing/FunctionDetail";
import { OrgSubscriptionFunctionService } from "src/app/_services/billing-pricing/Org-Subscription-Function.service";
import { environment } from "src/environments/environment";
import {
  StripeInstantPaymentSessionRequest,
  IStripeInstantPaymentSessionRequest,
  StripeInstantPaymentInvoiceItem,
  StripeSessionRequest,
  IStripeSessionRequest,
} from "src/app/_models/stripe/stripe";
declare var Stripe: any;
import { SaveOrderCartDetailsService } from "src/app/_services/cart-order/SaveOrder-Cart-Details.service";
import { StripeService } from "src/app/_services/stripe/stripe.service";
import { TranslateService } from "@ngx-translate/core";
import { Location } from "@angular/common";
import { parse } from "url";
import { OrgSubscription } from "src/app/_models/common/OrgSubscription";
import { BillingInvoiceForEnum } from "src/app/_models/enum/solo-enum";
import { Guid } from "guid-typescript";
import { PaymentMethodService } from "src/app/_services/billing-pricing/Payment-Method.service";
import { PaymentMethodList } from "src/app/_models/billing-pricing/PaymentMethodList";

@Component({
    selector: "stripe-invoice-failed-details-panel",
    templateUrl: "./stripe-invoice-failed-details-panel.component.html",
    standalone: false
})
export class StripeInvoiceFailedDetailsPanelComponent implements OnInit {
  @Output() closePanelEvent = new EventEmitter<boolean>();

  param: any;
  claims: Claims;
  orgGoogleInvoiceFailedRecord: any;
  orgTransactionDownloadInvoiceFailedRecord: any;
  orgSubscriptionInvoiceFailedRecord: any;
  paymentCurrency: string;
  customerId: string = "";
  stripeSessionId: any;
  stripeSessionIdFromUrl: string;
  submitted: boolean = false;

  constructor(
    private claimsService: ClaimsService,
    private toastr: ToastrService,
    private router: Router,
    private route: ActivatedRoute,
    private organisationSubscriptionInvoiceService: OrganisationSubscriptionInvoiceService,
    private orgSubscriptionFunctionService: OrgSubscriptionFunctionService,
    private saveOrderCartDetailsService: SaveOrderCartDetailsService,
    private stripeService: StripeService,
    private elRef: ElementRef,
    private translate: TranslateService,
    private location: Location,
    private paymentMethodService: PaymentMethodService,
  ) {
    this.claimsService.currentClaims.subscribe((claims) => {
      this.claims = claims;
    });
  }

  ngOnInit() {
    if (this.route.snapshot.queryParams["sessionId"]) {
      this.stripeSessionIdFromUrl =
        this.route.snapshot.queryParams["sessionId"];

      this.fnResetUrl();
      this.fnConfirmInstantPayment();
    }
    // Stripe card-update (setup mode) Checkout redirects back with changeCardSessionId.
    if (this.route.snapshot.queryParams["changeCardSessionId"]) {
      this.stripeSessionIdFromUrl =
        this.route.snapshot.queryParams["changeCardSessionId"];

      this.fnResetUrl();
      this.fnCompleteCardUpdate();
    }
    this.fnGetOrganisationInvoiceFailedRecords();
    this.fnGetOrganisationPaymentCurrency();
    this.fnGetStripeCustomerDetails();
    this.fnLoadStripe();
    this.getPaymentType();
  }

  fnClosePanel() {
    this.closePanelEvent.emit(true);
  }

  fnGetOrganisationInvoiceFailedRecords() {
    this.organisationSubscriptionInvoiceService
      .GetOrganisationInvoiceFailedRecords(this.claims.OrgId)
      .subscribe(
        (data) => {
          if (data.statusCode == 0) {
            
            this.orgGoogleInvoiceFailedRecord =
              data.responseInfo.orgGoogleInvoiceFailedRecord;

              this.orgTransactionDownloadInvoiceFailedRecord =
              data.responseInfo.orgTransactionDownloadInvoiceFailedResponse;

            this.orgSubscriptionInvoiceFailedRecord =
              data.responseInfo.orgSubscriptionInvoiceFailedRecord;

              this.showCardExpiryNotification = false;

              // Org may have no saved card yet (null response / null expiry).
              let cardExpirationMonthYear: string =
                data.responseInfo.orgStripeCustomerDetailsResponse?.cardExpirationMonthYear;
              if (cardExpirationMonthYear?.length == 7)
              {
                  var cardExpirationMonth = cardExpirationMonthYear.split("/")[0];
                  var cardExpirationYear = cardExpirationMonthYear.split("/")[1];
                  var lastDateOfMonth = new Date(Number(cardExpirationYear), Number(cardExpirationMonth), 0);
                  // Compare dates only (no time of day), exactly like the login check in
                  // BillingRepositoryService; otherwise after midday this is a day short and a
                  // milestone day (90/60/45/30/15) opens the panel with nothing to show.
                  let today = new Date();
                  today.setHours(0, 0, 0, 0);
                  let diffTime = (lastDateOfMonth.getTime() - today.getTime());
                  let differenceInDays = (Math.round(diffTime / (1000 * 3600 * 24))) +1;
                  this.cardExpiryDays = differenceInDays;
                  
                  if (differenceInDays == 90 || differenceInDays == 60 || differenceInDays == 45 || differenceInDays == 30 || differenceInDays == 15 || differenceInDays <= 7)
                  {
                      this.showCardExpiryNotification = true;
                  }
              }


            if (
              !this.orgGoogleInvoiceFailedRecord &&
              !this.orgSubscriptionInvoiceFailedRecord &&
              !this.showCardExpiryNotification &&
              !this.orgTransactionDownloadInvoiceFailedRecord
            ) {
              this.claims.isStripPaymentFailed = false;
              this.claimsService.updateClaims(this.claims);
            }
          }
        },
        (error) => {
          this.toastr.error(error);
        }
      );
  }

  fnGetOrganisationPaymentCurrency() {
    let request = new ApiRequest<FunctionDetail>(
      "SoloGetOrganisationPaymentCurrency",
      environment.applicationVersion,
      environment.requestId
    );
    request.requestInfo = new FunctionDetail(
      0,
      this.claims.CurrentOrganisationCurrencyId != null
        ? this.claims.CurrentOrganisationCurrencyId
        : Number(this.claims.SelectedCurrency)
    );
    this.orgSubscriptionFunctionService
      .getOrganisationPaymentCurrency(request)
      .subscribe((data) => {
        if (data.statusCode == 0) {
          this.paymentCurrency = data.responseInfo.currencyName;
        }
      });
  }

  fnLoadStripe() {
    var stripeImport = document.createElement("script");
    stripeImport.type = "text/javascript";
    stripeImport.src = "https://js.stripe.com/v3/";
    this.elRef.nativeElement.appendChild(stripeImport);
  }

  fnResetUrl() {
    let myUrl = parse(window.location.href);

    if (!(!myUrl || null) && !(!myUrl.pathname || null)) {
      let urlPath = myUrl.pathname;
      this.location.go(urlPath);
    } else {
      this.location.go("/");
    }
  }

  fnGetStripeCustomerDetails() {
    this.saveOrderCartDetailsService
      .GetStripeCustomerDetailsByOrgId(this.claims.OrgId)
      .subscribe((response) => {
        if (response.statusCode == 0 && response.responseInfo) {
          this.customerId = response.responseInfo.paymentCustomerId;
        }
      });
  }

  fnShowStripeCheckoutWindow() {
    var stripe = Stripe(environment.StripePublicKey);
    stripe
      .redirectToCheckout({
        sessionId: this.stripeSessionId,
      })
      .then((result) => {
        // Only resolves when the redirect failed (e.g. blocked / network error).
        this.submitted = false;
        if (result?.error) {
          this.toastr.error(result.error.message);
        }
      });
  }

  fnPaySubscription() {
    this.submitted = true;
    this.fnCreateSubscriptionPayObject();
  }

  fnCreateSubscriptionPayObject() {
    this.fnLoadStripeSessionForSubscriptionInstantPayment();
  }

  fnLoadStripeSessionForSubscriptionInstantPayment() {
    let userEmail =
      this.claims.EmailId && this.claims.EmailId != ""
        ? this.claims.EmailId
        : this.claims.LoginId;
    let invoiceItem = new StripeInstantPaymentInvoiceItem();
    invoiceItem.Name = "Subscription Pay";

    invoiceItem.Amount =
      this.orgSubscriptionInvoiceFailedRecord.invoiceAmount * 100;
    invoiceItem.Currency = this.paymentCurrency.toLowerCase();
    invoiceItem.Quantity = 1;

    let invoiceItemList = [];
    invoiceItemList.push(invoiceItem);

    let sessionRequestData = new StripeInstantPaymentSessionRequest(
      window.location.href,
      this.customerId,
      userEmail,
      this.claims.CurrentOrganisationCurrencyCode,
      invoiceItemList,
      BillingInvoiceForEnum.Subscription,
      this.orgSubscriptionInvoiceFailedRecord.organisationSubscriptionInvoiceID
    );
    let sessionRequest = new ApiRequest<IStripeInstantPaymentSessionRequest>(
      "CreateStripeSessionForInstantPayment",
      environment.applicationVersion,
      environment.requestId
    );

    sessionRequest.requestInfo = sessionRequestData;

    if (invoiceItem.Amount > 0) {
      this.stripeService
        .CreateStripeSessionForInstantPayment(sessionRequest)
        .subscribe(
          (sessionData) => {
            if (sessionData.statusCode == 0 && sessionData.responseInfo) {
              this.stripeSessionId = sessionData.responseInfo;
              this.fnShowStripeCheckoutWindow();
            }
          },
          (error) => {
            this.submitted = false;
          }
        );
    }
  }

  fnPayGooglePackage() {
    this.submitted = true;
    this.fnCreateGooglePackagePayObject();
  }

  fnCreateGooglePackagePayObject() {
    this.fnLoadStripeSessionForGooglePackageInstantPayment();
  }

  fnLoadStripeSessionForGooglePackageInstantPayment() {
    let userEmail =
      this.claims.EmailId && this.claims.EmailId != ""
        ? this.claims.EmailId
        : this.claims.LoginId;
    let invoiceItem = new StripeInstantPaymentInvoiceItem();
    invoiceItem.Name = "Google Package Pay";

    invoiceItem.Amount = this.orgGoogleInvoiceFailedRecord.amountPaid * 100;
    invoiceItem.Currency = this.paymentCurrency.toLowerCase();
    invoiceItem.Quantity = this.orgGoogleInvoiceFailedRecord.unitsPurchased;

    let invoiceItemList = [];
    invoiceItemList.push(invoiceItem);

    let sessionRequestData = new StripeInstantPaymentSessionRequest(
      window.location.href,
      this.customerId,
      userEmail,
      this.claims.CurrentOrganisationCurrencyCode,
      invoiceItemList,
      BillingInvoiceForEnum.GooglePackageService,
      this.orgGoogleInvoiceFailedRecord.organisationGooglePackagePaymentDetailId
    );
    let sessionRequest = new ApiRequest<IStripeInstantPaymentSessionRequest>(
      "CreateStripeSessionForInstantPayment",
      environment.applicationVersion,
      environment.requestId
    );

    sessionRequest.requestInfo = sessionRequestData;

    if (invoiceItem.Amount > 0) {
      this.stripeService
        .CreateStripeSessionForInstantPayment(sessionRequest)
        .subscribe(
          (sessionData) => {
            if (sessionData.statusCode == 0 && sessionData.responseInfo) {
              this.stripeSessionId = sessionData.responseInfo;
              this.fnShowStripeCheckoutWindow();
            }
          },
          (error) => {
            this.submitted = false;
          }
        );
    }
  }

  // Stripe Checkout redirected back after paying a failed invoice. The server verifies the
  // session with Stripe and marks the invoice paid (the Stripe webhook does the same, so the
  // DB is updated even if the customer never comes back here).
  fnConfirmInstantPayment() {
    this.stripeService
      .ConfirmStripeInstantPayment(this.stripeSessionIdFromUrl)
      .subscribe((data) => {
        // false = not paid yet (e.g. a bank debit still processing); the webhook completes it later.
        if (data.statusCode == 0 && data.responseInfo) {
          this.toastr.success(this.translate.instant("success"));
        }
        this.fnGetOrganisationInvoiceFailedRecords();
      });
  }

  goToCardUpdate() {
    this.submitted = true;
    this.loadStripeSessionForExistingCustomer();
  }

  // Stripe card-update Checkout redirected back. The server verifies the session with Stripe,
  // makes the new card the default and saves its details (expiry etc.) in
  // OrganisationSubscriptionCardDetails, which the card-expiry notice is computed from. The Stripe
  // webhook does the same, so the card is saved even if the customer never comes back here.
  fnCompleteCardUpdate() {
    this.stripeService
      .CompleteStripeCardUpdate(this.stripeSessionIdFromUrl)
      .pipe(first())
      .subscribe((data) => {
        if (data.statusCode == 0 && data.responseInfo) {
          this.toastr.success(this.translate.instant("success"));
          // Re-evaluates the expiry notice from the new card; closes the panel if nothing is left.
          this.fnGetOrganisationInvoiceFailedRecords();
          this.getPaymentType();
        } else {
          this.toastr.error(this.translate.instant("failed"));
        }
      });
  }

  showCardExpiryNotification = false;
  userEmailId = "";
  loginId = "";

  // Stripe Change Card - Start
  loadStripeSessionForExistingCustomer() {
    this.loginId = this.claims.LoginId;
    this.userEmailId = this.claims.EmailId;

    var userEmail =
      this.userEmailId && this.userEmailId != ""
        ? this.userEmailId
        : this.loginId;

    let sessionRequestData = new StripeSessionRequest(
      window.location.href,
      userEmail,
      this.claims.CurrentOrganisationCurrencyCode,
      window.location.href
    );
    let sessionRequest = new ApiRequest<IStripeSessionRequest>(
      "SoloCreateStripeSessionForExistingCustomer",
      1.0,
      "111"
    );

    sessionRequest.requestInfo = sessionRequestData;

    this.stripeService
      .CreateStripeSessionForExistingCustomer(sessionRequest)
      .pipe(first())
      .subscribe(
        (sessionData) => {
          if (sessionData.statusCode == 0 && sessionData.responseInfo) {
            this.stripeSessionId = sessionData.responseInfo;
            this.showStripeCheckoutWindow();
          } else {
            this.submitted = false;
          }
        },
        (error) => {
          this.submitted = false;
        }
      );
  }

  showStripeCheckoutWindow() {
    var stripe = Stripe(environment.StripePublicKey);

    stripe
      .redirectToCheckout({
        sessionId: this.stripeSessionId,
      })
      .then((result) => {
        // Only resolves when the redirect failed (e.g. blocked / network error).
        this.submitted = false;
        if (result?.error) {
          this.toastr.error(result.error.message);
        }
      });
  }

  paymentTypeResponse: PaymentMethodList[] = [];
  OrgPaymentTypeRequest: IApiRequest<OrgSubscription>;
  UniqueId:Guid;
  cardExpiryDays = 0;

  getPaymentType() {

    this.UniqueId = Guid.create();
    this.OrgPaymentTypeRequest = new ApiRequest<OrgSubscription>(
      "SoloOrganisationPaymentMethod",
      0,
      this.UniqueId.toString()
    );
    this.OrgPaymentTypeRequest.requestInfo = new OrgSubscription(
      this.claims.OrgId
    );
    this.paymentMethodService
      .getPaymentTypeList(this.OrgPaymentTypeRequest)
      .pipe(first())
      .subscribe(
        (data) => {
          if (data.statusCode == 0) {
            this.paymentTypeResponse = data.responseInfo;
          } else {
            this.toastr.error(data.errorInfo[0].message);
          }
        },
        (error) => {
          this.toastr.error(error);
        }
      );
  }


  fnPayAutomaticTransactionDownload(){
    this.submitted = true;
    this.fnCreateTransactionDownloadPackagePayObject();
  }

  
  fnCreateTransactionDownloadPackagePayObject() {
    this.fnLoadStripeSessionForTransactionDownloadInstantPayment();
  }

  fnLoadStripeSessionForTransactionDownloadInstantPayment() {
    let userEmail =
      this.claims.EmailId && this.claims.EmailId != ""
        ? this.claims.EmailId
        : this.claims.LoginId;
    let invoiceItem = new StripeInstantPaymentInvoiceItem();
    invoiceItem.Name = "Automatic Transaction download";

    invoiceItem.Amount = this.orgTransactionDownloadInvoiceFailedRecord.amountPaid * 100;
    invoiceItem.Currency = this.paymentCurrency.toLowerCase();
    invoiceItem.Quantity = this.orgTransactionDownloadInvoiceFailedRecord.unitsPurchased;

    let invoiceItemList = [];
    invoiceItemList.push(invoiceItem);

    let sessionRequestData = new StripeInstantPaymentSessionRequest(
      window.location.href,
      this.customerId,
      userEmail,
      this.claims.CurrentOrganisationCurrencyCode,
      invoiceItemList,
      BillingInvoiceForEnum.PlaidPackageService,
      this.orgTransactionDownloadInvoiceFailedRecord.organisationPlaidPackagePaymentDetailId
    );
    let sessionRequest = new ApiRequest<IStripeInstantPaymentSessionRequest>(
      "CreateStripeSessionForInstantPayment",
      environment.applicationVersion,
      environment.requestId
    );

    sessionRequest.requestInfo = sessionRequestData;

    if (invoiceItem.Amount > 0) {
      this.stripeService
        .CreateStripeSessionForInstantPayment(sessionRequest)
        .subscribe(
          (sessionData) => {
            if (sessionData.statusCode == 0 && sessionData.responseInfo) {
              this.stripeSessionId = sessionData.responseInfo;
              this.fnShowStripeCheckoutWindow();
            }
          },
          (error) => {
            this.submitted = false;
          }
        );
    }
  }

  onUpdateLater(){
    this.showCardExpiryNotification = false;

    // "Update later" only snoozes the card-expiry notice. Keep the panel (and the flag) while a
    // failed payment is still outstanding, otherwise it would be hidden until the next login.
    if (
      !this.orgGoogleInvoiceFailedRecord &&
      !this.orgSubscriptionInvoiceFailedRecord &&
      !this.orgTransactionDownloadInvoiceFailedRecord
    ) {
      this.claims.isStripPaymentFailed = false;
      this.closePanelEvent.emit(true);
    }
  }
}

